import React from 'react'
import { Section, Heading } from 'components'
import { useStaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const TempTestimonials = ({ testimonials }) => {
  const {
    allFile: { edges: images },
  } = useStaticQuery(graphql`
    {
      allFile(filter: { sourceInstanceName: { eq: "images" } }) {
        edges {
          node {
            name
            url
            publicURL
            childImageSharp {
              gatsbyImageData(width: 100, quality: 100)
            }
          }
        }
      }
    }
  `)

  return (
    <Section>
      <div className="space-y-8 max-w-3xl mx-auto text-center">
        <Heading type="kicker">Testimonials & Reviews</Heading>
        <Heading>What our customers are saying</Heading>
      </div>

      <div className="mt-16 grid grid-cols-3 gap-8">
        {testimonials.map(({ testimonial, author, rating, role, picture }) => {
          const [imageUrl] = images.filter((imageUrl) => {
            return imageUrl.node.name === picture.title
          })

          return (
            <div className="border border-gray-100 rounded space-y-3 p-8">
              <quote className="italic font-serif">"{testimonial}"</quote>
              <hr />

              <div className="flex space-x-6">
                <div className="w-16 h-16 flex-shrink-0 rounded-full bg-gray-50">
                  {imageUrl && (
                    <div className="overflow-auto">
                      <GatsbyImage
                        objectFit="cover"
                        alt={
                          imageUrl.node.altText
                            ? imageUrl.node.altText
                            : imageUrl.node.title
                        }
                        image={getImage(imageUrl.node)}
                      />
                    </div>
                  )}
                </div>
                <div className="space-y-1">
                  <div className="text-sm font-bold">{author}</div>
                  <div className="text-xs text-gray-400">{role}</div>
                  <Stars />
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </Section>
  )
}

export default TempTestimonials

export const Stars = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="91.636"
        height="15.636"
        viewBox="0 0 91.636 15.636"
      >
        <g id="Group_173" data-name="Group 173" transform="translate(0)">
          <g id="Group_162" data-name="Group 162" transform="translate(0)">
            <path
              id="Path_54"
              data-name="Path 54"
              d="M0,0H15.636V15.636H0Z"
              fill="none"
            />
            <path
              id="Path_55"
              data-name="Path 55"
              d="M8.023,12.071l-4.6,2.572L4.454,9.478.587,5.9l5.23-.62L8.023.5l2.206,4.782,5.23.62L11.591,9.478l1.026,5.165Z"
              transform="translate(-0.205 -0.174)"
              fill="#fbbf24"
            />
          </g>
          <g id="Group_163" data-name="Group 163" transform="translate(19)">
            <path
              id="Path_54-2"
              data-name="Path 54"
              d="M0,0H15.636V15.636H0Z"
              fill="none"
            />
            <path
              id="Path_55-2"
              data-name="Path 55"
              d="M8.023,12.071l-4.6,2.572L4.454,9.478.587,5.9l5.23-.62L8.023.5l2.206,4.782,5.23.62L11.591,9.478l1.026,5.165Z"
              transform="translate(-0.205 -0.174)"
              fill="#fbbf24"
            />
          </g>
          <g id="Group_164" data-name="Group 164" transform="translate(38)">
            <path
              id="Path_54-3"
              data-name="Path 54"
              d="M0,0H15.636V15.636H0Z"
              fill="none"
            />
            <path
              id="Path_55-3"
              data-name="Path 55"
              d="M8.023,12.071l-4.6,2.572L4.454,9.478.587,5.9l5.23-.62L8.023.5l2.206,4.782,5.23.62L11.591,9.478l1.026,5.165Z"
              transform="translate(-0.205 -0.174)"
              fill="#fbbf24"
            />
          </g>
          <g id="Group_165" data-name="Group 165" transform="translate(57)">
            <path
              id="Path_54-4"
              data-name="Path 54"
              d="M0,0H15.636V15.636H0Z"
              fill="none"
            />
            <path
              id="Path_55-4"
              data-name="Path 55"
              d="M8.023,12.071l-4.6,2.572L4.454,9.478.587,5.9l5.23-.62L8.023.5l2.206,4.782,5.23.62L11.591,9.478l1.026,5.165Z"
              transform="translate(-0.205 -0.174)"
              fill="#fbbf24"
            />
          </g>
          <g id="Group_166" data-name="Group 166" transform="translate(76)">
            <path
              id="Path_54-5"
              data-name="Path 54"
              d="M0,0H15.636V15.636H0Z"
              fill="none"
            />
            <path
              id="Path_55-5"
              data-name="Path 55"
              d="M8.023,12.071l-4.6,2.572L4.454,9.478.587,5.9l5.23-.62L8.023.5l2.206,4.782,5.23.62L11.591,9.478l1.026,5.165Z"
              transform="translate(-0.205 -0.174)"
              fill="#fbbf24"
            />
          </g>
        </g>
      </svg>
    </>
  )
}
